//我的账户
<template>
    <div id="contactDetails">
        <el-row :gutter="30">
            <el-col :span="12" v-for="item in list" :key="item.title">
                <el-form label-position="left" label-width="100px">
                    <p class="title">{{ item.title }}</p>
                    <el-form-item v-for="val in item.data" :key="val.id" :label="val.label">
                        <el-input v-model="data[val.id]" :disabled="val.disabled"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :span="3" :offset="4">
                <el-button @click="postVeruify">获取验证码</el-button>
            </el-col>
            <el-col :span="6">
                <el-input v-model="verify"></el-input>
            </el-col>
            <el-col :span="3">
                <el-button :disabled="verify.length <= 0" @click="changeContact">保存</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { fetch, post } from "@/util/http";
import { mapGetters } from "vuex";
export default {
    name: "ContactDetails",
    beforeCreate() {
        let self = this;
        let token = sessionStorage.getItem("authToken");
        if (!token) {
            this.$router.push({
                name: "pcibLogin"
            });
        }
    },
    mounted() {
        // 绑定联系人默认数据
        this.getContactsList.forEach(item => {
            if (item.id === this.contact_id) {
                this.data.contact = item.user.contact;
                this.data.phone = item.user.phone;
                this.data.email = item.user.email;
            }
        });
    },
    data() {
        return {
            data: {
                contact: "",
                new_contact: "",
                phone: "",
                new_phone: "",
                email: "",
                new_email: ""
            },
            verify: "",
            list: {
                old_contact: {
                    title: "当前联系人",
                    data: {
                        contact: {
                            label: "联系人",
                            id: "contact",
                            disabled: true
                        },
                        phone: {
                            label: "电话",
                            id: "phone",
                            disabled: true
                        },
                        email: {
                            label: "邮箱",
                            id: "email",
                            disabled: true
                        }
                    }
                },
                new_contact: {
                    title: "新联系人",
                    data: {
                        contact: {
                            label: "联系人",
                            id: "new_contact",
                            disabled: false
                        },
                        phone: {
                            label: "电话",
                            id: "new_phone",
                            disabled: false
                        },
                        email: {
                            label: "邮箱",
                            id: "new_email",
                            disabled: false
                        }
                    }
                }
            }
        };
    },
    computed: {
        contact_id() {
            return this.$route.query.contact_id;
        },
        ...mapGetters("config", {
            getContactsList: "getContactsList"
        })
    },
    methods: {
        // 获取验证码
        postVeruify() {
            fetch(`ecla/contact_verify/${this.contact_id}/`).then(
                res => {
                    // if (res === "发送成功") {
                    this.$notify({
                        type: "success",
                        message: "验证码已发送到您的邮箱",
                        duration: 4000
                    });
                    // }
                },
                err => {
                    this.$notify({
                        type: "error",
                        message: "验证码发送失败，请重试",
                        duration: 4000
                    });
                }
            );
        },
        // 更改联系人
        changeContact() {
            if (
                this.data.new_contact.trim() === "" &&
                this.data.new_phone.trim() === "" &&
                this.data.new_email.trim() === ""
            ) {
                this.$notify({
                    type: "info",
                    message: "新建联系人信息不能为空",
                    duration: 4000
                });
                return false;
            }
            post(`ecla/change_contact/${this.contact_id}/`, {
                contact: this.data.new_contact,
                phone: this.data.new_phone,
                email: this.data.new_email,
                verify: this.verify
            }).then(
                res => {
                    this.$notify({
                        type: "success",
                        message: "新联系人修改成功，密码已发送到您的邮箱",
                        duration: 4000
                    });
                    this.$router.push({
                        name: "pcibList"
                    });
                },
                err => {
                    this.$notify({
                        type: "error",
                        message: err.data.msg,
                        duration: 4000
                    });
                }
            );
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/ContactDetails.vue